module.exports = __webpack_public_path__ + "static/aeg_logo-3901071b6a144f96225fc6b46e37503b.png";